module.exports = __webpack_public_path__ + "static/furniture-support-info-section-code-24238dcc783b48248a6a1da9fe81f219.png";